import React from "react";
import Card from "../../components/DashboardCard";
import { IconList } from "../../components/IconList";
import LastWorkedOn from "./LastWorkedOn";
import ProgressUpdate from "./ProgressUpdate";
import StatusUpdateRow from "../../components/StatusUpdateRow";
import StyledCaseUpdateInfo from "./StyledCaseUpdateInfo";
import { formatDateTime } from "../../utils/textUtils";

function StatusUpdate(props) {
  const statusUpdate = props.selectedCase.status_updates?.client_dashboard_overview;

  if (!statusUpdate) {
    // Brokers reach this for every case type, so a probate case with no status shows nothing
    if (props.selectedCase.case_type === "probate") {
      return null;
    }

    return (
      <Card title="Current status" headingLevel="3" headingSize="2">
        We haven’t created a status update yet - soon you’ll be able to view the progress of your case here.
      </Card>
    );
  }

  const statusUpdateRows = statusUpdate.sections.map((section, index) => {
    return (
      <StatusUpdateRow
        key={index}
        title={section.title}
        descriptions={section.descriptions}
        description_blocks={section.description_blocks}
        status={section.status}
      />
    );
  });

  // The snippet opens the card as the client mirror of the estate agent "Live update" panel,
  // above the deterministic checklist it summarises.
  return (
    <>
      <Card title={props.title} headingLevel="3" headingSize="2" id="current-status">
        <ProgressUpdate progressUpdate={props.progressUpdate} />
        <IconList cols={1}>{statusUpdateRows}</IconList>
        <StyledCaseUpdateInfo>Status updated: {formatDateTime(statusUpdate.last_updated)}</StyledCaseUpdateInfo>
        <LastWorkedOn selectedCase={props.selectedCase} />
      </Card>
    </>
  );
}

export default StatusUpdate;
